// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xOtMuMCqLnxP4cctVF4P {\n  font-family: Poppins, sans-serif;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  min-height: calc(100vh - 80px);\n}\n\n._RtfxvYNnqrW2gmydYLM {\n  height: 80px !important;\n  background: linear-gradient(to right, #0844a6 0%, #086590 48.96%, #088077 100%);\n}\n._RtfxvYNnqrW2gmydYLM .BUttbR0ryiqWwOf31hvA {\n  height: 100%;\n  display: flex;\n}\n._RtfxvYNnqrW2gmydYLM .BUttbR0ryiqWwOf31hvA img {\n  margin: auto;\n}\n\n.aP7e7WN6uWwgaSmHX1O_ {\n  cursor: pointer;\n  text-decoration: none;\n}\n.aP7e7WN6uWwgaSmHX1O_:hover {\n  text-decoration: none;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": "xOtMuMCqLnxP4cctVF4P",
	"header": "_RtfxvYNnqrW2gmydYLM",
	"headerLogo": "BUttbR0ryiqWwOf31hvA",
	"anchorText": "aP7e7WN6uWwgaSmHX1O_"
};
export default ___CSS_LOADER_EXPORT___;
